import styled from 'styled-components';

interface Props {
  color?: string;
}

export const Container = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  @keyframes ldio-1fy5qn15irf {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  .loadingio-spinner-rolling-5kt3aau2lso {
    width: 100px;
    height: 100px;
    display: inline-block;
    overflow: hidden;
    background: none;

    .ldio-1fy5qn15irf {
      width: 100%;
      height: 100%;
      position: relative;
      transform: translateZ(0) scale(1);
      backface-visibility: hidden;
      transform-origin: 0 0; /* see note above */

      div {
        position: absolute;
        width: 60px;
        height: 60px;
        border: 10px solid
          ${(props) =>
            props.color === 'primary'
              ? props.theme.colors.primaryLighter
              : '#ffffff'};
        border-top-color: transparent;
        border-radius: 50%;
        animation: ldio-1fy5qn15irf 1s linear infinite;
        top: 50px;
        left: 50px;
        box-sizing: content-box;
      }
      /* generated by https://loading.io/ */
    }
  }
`;
